import { useEffect, useRef, useState } from "react";

import { api_without_cancellation } from "../api/api";
import { getCaseId, getClientId } from "../Utils/helper";

function DatesGapDropdown({ setTreatmentDateData2, selectedGap, setSelectedGap, setShowGap }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleGapDropdown = () => setIsOpen(!isOpen);
  const handleGapDropdownClick = (item) => {
    setShowGap(true);
    setSelectedGap(item);
    toggleGapDropdown();
    fetchTreatmentDateGapData(item);
  };

  const fetchTreatmentDateGapData = async (item) => {
    const body = {
      timeframe: item,
      client_id: getClientId(),
    };

    try {
      const response = await api_without_cancellation.post(
        `/api/treatment/dates_treatment/${getCaseId()}/`,
        body
      );
      if (response.status === 200) {
        setTreatmentDateData2(response?.data?.data);
        setShowGap(false);
      }
    } catch (error) {
      //
    }
  };
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={dropdownRef}
      className="dropdown  notes-category-wrapper m-r-5 m-l-5 d-block"
      style={{
        background: "#fff",
        border: "1px solid #ced4da",
        position: "relative",
        minWidth: "185px",
      }}
    >
      <button
        className="dropdown-toggle footer-select notes-category text-start d-flex align-items-center height-25"
        type="button"
        onClick={toggleGapDropdown}
        aria-expanded={isOpen}
        id="dropdownMenuLink"
        aria-haspopup="true"
        style={{
          gap: "10px",
          justifyContent: "space-between",
          minWidth: "185px",
        }}
      >
        <span
          className="d-flex align-items-center text-truncate"
          style={{
            color: "black",
            // textTransform: "uppercase",
            fontWeight: "600",
          }}
        >
          {selectedGap === "Do not show gaps" ? "No Gaps" : selectedGap || "No Gaps"}
        </span>
        <span className="ic ic-17 height-100 has-no-after  ms-0 text-primary d-flex align-items-center justify-content-center">
          <svg
            width={34}
            height={17}
            viewBox="0 0 34 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.00683594 0H9.20684L17.0069 7.85384L24.807 0H34.007L17.0069 17L0.00683594 0Z"
              fill="currentColor"
            />
          </svg>
        </span>
      </button>
      {isOpen && (
        <div
          className="dropdown-menu mt-0 w-100 p-0 d-block"
          aria-labelledby="dropdownMenuLink"
          id=""
          style={{
            left: "-1px",
            top: "26px",
            minWidth: "187px",
          }}
        >
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item p-0 p-l-5 height-25"
            onClick={() => handleGapDropdownClick("1 week")}
          >
            1 Week
          </a>
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item p-0 p-l-5 height-25"
            onClick={() => handleGapDropdownClick("2 weeks")}
          >
            2 weeks
          </a>
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item p-0 p-l-5 height-25"
            onClick={() => handleGapDropdownClick("3 weeks")}
          >
            3 weeks
          </a>
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item height-25 p-0 p-l-5"
            onClick={() => handleGapDropdownClick("30 days")}
          >
            30 days
          </a>
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item height-25 p-0 p-l-5"
            onClick={() => handleGapDropdownClick("60 days")}
          >
            60 days
          </a>
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item height-25 p-0 p-l-5"
            onClick={() => handleGapDropdownClick("90 days")}
          >
            90 days
          </a>
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item height-25 p-0 p-l-5"
            onClick={() => handleGapDropdownClick("180 days")}
          >
            180 days
          </a>
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item height-25 p-0 p-l-5"
            onClick={() => handleGapDropdownClick("1 year")}
          >
            1 year
          </a>
          <a
            style={{
              fontWeight: "600",
            }}
            className="dropdown-item height-25 p-0 p-l-5"
            onClick={() => handleGapDropdownClick("Do not show gaps")}
          >
            No Gaps
          </a>
        </div>
      )}
    </div>
  );
}

export default DatesGapDropdown;
